import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { refreshUser, updateAddress } from "../../appState/slices/auth/authSlice";
import { setToastMessage } from "../../appState/slices/util/utilSlice";

const HomeAddress = ({ address,addresstype }) => {
    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm();
    const dispatch = useDispatch();
    const onSubmitHome = async(data) => {
        try {
            await dispatch(
                updateAddress({
                addressLine1 : data.address1,
                addressLine2 : data.address2,
                city : data.town,
                postalCode : data.pincode,
                state : data.state,
                addressType : addresstype 
            })
            )
            await dispatch(refreshUser());
            await dispatch(setToastMessage({
                type: "success",
                message: "Address Updated Successfully",
                show: true,
            }))
        } catch (error) {
            await dispatch(setToastMessage({
                type: "error",
                message: "Something went wrong",
                show: true,
            }))
        }
       
    }
    return (
        <div>
            <form className="profile-address-container" onSubmit={handleSubmit(onSubmitHome)}>
                <div className="t4 font-semibold">
                    {address.addressType}
                </div>
                <Controller
                    name="address1"
                    control={control}
                    defaultValue= {address ? address.addressLine1 : ""}
                    render={({ field }) => (
                        <div className="delivery-input-container" >
                            <input type="address" placeholder="address line 1" {...field} />
                        </div>
                    )}
                />
                <Controller
                    name="address2"
                    control={control}
                    defaultValue= {address ? address.addressLine2 : ""}
                    render={({ field }) => (
                        <div className="delivery-input-container" >
                            <input type="address" placeholder="address line 2" {...field} />
                        </div>
                    )}
                />
                <div className="horizontalgroupaddress">
                    <Controller
                        name="town"
                        control={control}
                        defaultValue= {address ? address.city : ""}
                        render={({ field }) => (
                            <div className="delivery-input-container" >
                                <input type="town" placeholder="town/city" {...field} />
                            </div>
                        )}
                    />
                    <Controller
                        name="pincode"
                        control={control}
                        defaultValue= {address ? address.postalCode : ""}
                        render={({ field }) => (
                            <div className="delivery-input-container" >
                                <input type="number" placeholder="pin code" {...field} />
                            </div>
                        )}
                    />
                </div>
                <Controller
                    name="state"
                    control={control}
                    defaultValue= {address ? address.state : ""}
                    render={({ field }) => (
                        <div className="delivery-input-container" >
                            <input type="state" placeholder="state" {...field} />
                        </div>
                    )}
                />
                <button className="address-update-btn font-semibold t5" type="submit">
                    Update
                </button>
            </form>
        </div>
    )
}

export default HomeAddress;